import type { AdminBanner } from "./banner.ts";

/**
 * PC-web idle-pause placement (see MatchScreen.tsx's idleAdVisible/IDLE_AD_MS)
 * — the web counterpart of ADMOB_IDLE_INTERSTITIAL_UNIT_ID: same 60s trigger,
 * but there's no AdMob on PC web, so this shows the admin-managed "전면배너"
 * instead. Closes only via the X button so an accidental backdrop click
 * doesn't waste the impression.
 */
export function BannerInterstitial({ banner, onClose }: { banner: AdminBanner; onClose: () => void }) {
  return (
    <div className="modal-backdrop">
      <div className="banner-interstitial">
        <button type="button" className="banner-interstitial-close" onClick={onClose} aria-label="닫기">✕</button>
        <a
          className="banner-interstitial-link"
          href={banner.linkUrl || "#"}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
        >
          <img src={banner.imageUrl} alt="" />
        </a>
      </div>
    </div>
  );
}
